import React from 'react'
import ShortAnswerTest from '../components/test/ShortAnswerTest'

const ShortAnswerTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ShortAnswerTest />
    </div>
  )
}

export default ShortAnswerTestPage